// src/components/CommercialServices.js
import React, { useState } from 'react';
import '../../../styles/CustomerSiteStyles/CommercialServices.css';
import { useNavigate } from 'react-router-dom';

function CommercialServices() {
  const navigate = useNavigate();
  const handleContactNav = () => {
    navigate('/contact');
  };
  
  const services = [
    {
      title: 'EPDM Roofing',
      description:
        'We specialize in EPDM roofing solutions, offering durable and cost-effective options for your commercial building. EPDM roofs are known for their longevity and resistance to extreme weather conditions.',
    },
    {
      title: 'TPO Roofing',
      description:
        'Our TPO roofing systems provide energy efficiency and high performance. TPO is a popular choice for commercial roofs due to its reflective properties and resistance to UV radiation.',
    },
    {
      title: 'Flat Roof Services',
      description:
        'We offer expert installation, repair, and maintenance of flat roofing systems. Our team ensures your flat roof is properly installed and maintained for optimal performance.',
    },
    {
      title: 'Roof Repair',
      description:
        'Our skilled professionals provide prompt and reliable roof repair services to address leaks, storm damage, and wear and tear, extending the life of your commercial roof.',
    },
    {
      title: 'Roof Replacement',
      description:
        'When repair is no longer sufficient, we offer complete roof replacement services. We work with you to select the best roofing system for your building and budget.',
    },
    {
      title: 'Roof Maintenance',
      description:
        'Regular maintenance is key to prolonging the life of your roof. Our maintenance programs are tailored to your needs, ensuring your roof remains in top condition.',
    },
  ];

  return (
    <div className="commercial-container">
      {/* Hero Section with Parallax Effect */}
      <section className="commercial-hero">
        <div className="commercial-overlay">
          <div className="commercial-content">
            <h1>Professional Commercial Roofing Services</h1>
            <p>Quality Solutions for Your Business</p>
            <button onClick={handleContactNav} className="commercial-button">Contact Us</button>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="why-choose-content">
          <h2>Why Choose Affordable Roofing + Solar Solutions?</h2>
          
          <div className="features-grid">
            <div className="feature-item">
              <span className="material-icons">verified</span>
              <h3>Expert Technicians</h3>
              <p>Our team consists of skilled and certified professionals with extensive experience in commercial roofing.</p>
            </div>
            
            <div className="feature-item">
              <span className="material-icons">timer</span>
              <h3>Minimal Disruption</h3>
              <p>We work efficiently to complete projects on time with minimal impact to your business operations.</p>
            </div>
            
            <div className="feature-item">
              <span className="material-icons">inventory_2</span>
              <h3>Premium Materials</h3>
              <p>We use only high-quality materials from trusted manufacturers to ensure durability and performance.</p>
            </div>
            
            <div className="feature-item">
              <span className="material-icons">support_agent</span>
              <h3>Dedicated Support</h3>
              <p>Our customer service team provides transparent communication throughout your project.</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Insurance Claim Highlight Section */}
      <section className="insurance-highlight">
        <div className="insurance-content">
          <div className="insurance-text-container">
            <h2>Commercial Insurance Claims</h2>
            <div className="insurance-details">
              <div className="insurance-text">
                <p>Has your commercial property sustained storm damage? We specialize in commercial insurance claims, helping business owners navigate the complex process of filing and recovering from property damage.</p>
                <ul className="insurance-benefits">
                  <li><span className="material-icons">check_circle</span>Thorough roof inspections and documentation</li>
                  <li><span className="material-icons">check_circle</span>Direct coordination with insurance adjusters</li>
                  <li><span className="material-icons">check_circle</span>Detailed damage assessment reports</li>
                  <li><span className="material-icons">check_circle</span>Expert representation during the claims process</li>
                </ul>
                <button onClick={handleContactNav} className="insurance-button">Schedule an Inspection</button>
              </div>
              <div className="insurance-icon-container">
                <div className="insurance-icon">
                  <span className="material-icons">business</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services List Section */}
      <section className="commercial-services-section">
        <div className="commercial-services-header">
          <h2>Our Commercial Roofing Services</h2>
          <p>Comprehensive solutions for all your commercial property needs</p>
        </div>
        
        <div className="commercial-services-list">
          {services.map((service, index) => (
            <ServiceListItem key={index} service={service} />
          ))}
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="commercial-cta-section">
        <div className="commercial-cta-content">
          <h2>Protect Your Business with Quality Roofing</h2>
          <p>Contact us today for a free consultation and detailed quote.</p>
          <button onClick={handleContactNav} className="commercial-cta-button">Contact Our Team</button>
        </div>
      </section>
    </div>
  );
}

// Service List Item Component
function ServiceListItem({ service }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="service-list-item">
      <div className="service-list-header" onClick={toggleExpand}>
        <div className="service-list-title">
          <h3>{service.title}</h3>
        </div>
        <span className="material-icons toggle-icon">
          {expanded ? 'remove' : 'add'}
        </span>
      </div>
      
      {expanded && (
        <div className="service-list-content">
          <p>{service.description}</p>
        </div>
      )}
    </div>
  );
}

export default CommercialServices;